export const SORT_TYPES = {
    asc: "asc",
    desc: "desc"
}

export const SORT_BY = {
    name: "name",
    date_modified: "last_modified_at",
    total_size: "file_size"
}